









import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CustomPopup extends Vue {
    @Prop() private open: boolean;
}

Vue.component("mt-custom-popup", CustomPopup);
